// extracted by mini-css-extract-plugin
export default {"container":"DropdownMenu_container__GZcUC","iconContainer":"DropdownMenu_iconContainer__cqksh"};